window.addEventListener("DOMContentLoaded", () => {
  CookieConsent.run({
    // 默认不自动弹出横幅
    autoShow: false,
    mode: "opt-out",
    revision: 2.0,

    // 【新增】GUI 布局配置项
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom right",
      },
      // 控制偏好设置弹窗的布局
      preferencesModal: {
        layout: "box", // 'box' 表示居中弹窗 (区别于 'bar' 或侧边栏)
        equalWeightButtons: false, // 按钮不要平分宽度，根据文字自适应
        flipButtons: false, // 保持正常的 DOM 按钮顺序
      },
    },

    // 默认开启全部选项
    categories: {
      necessary: { readOnly: true, enabled: true },
      performance: { readOnly: false, enabled: true },
      functionality: { readOnly: false, enabled: true },
      targeting: { readOnly: false, enabled: true },
    },

    // UI 文本 (完全按照你的截图输入)
    language: {
      default: "de",
      translations: {
        de: {
          preferencesModal: {
            title: "Cookie-Einstellungen verwalten",
            acceptAllBtn: "Alle Cookies akzeptieren",
            acceptNecessaryBtn: "Nur erforderliche Cookies",
            savePreferencesBtn: "Auswahl bestätigen",
            closeIconLabel: "Dialogfenster schließen",
            sections: [
              {
                title: "Ihre Datenschutzeinstellungen",
                description:
                  "Wir und unsere Drittanbieter verwenden Cookies und andere Tracking-Technologien („Cookies“), um automatisch Informationen über Ihren Besuch auf unserer Website zu erfassen. Dies dient dazu, die ordnungsgemäße Funktion der Website sicherzustellen, Nutzungsstatistiken zu erstellen, Werbung zu personalisieren, den Erfolg unserer Marketingkampagnen zu messen, Ihnen ein personalisiertes Web-Erlebnis zu bieten und weitere in unseren Datenschutzhinweisen beschriebene Zwecke zu erfüllen.<br>Da uns der Schutz Ihrer Privatsphäre wichtig ist, können Sie die Verwendung bestimmter Cookie-Kategorien ablehnen. Klicken Sie auf die einzelnen Kategorien, um weitere Informationen zu erhalten und die Standardeinstellungen anzupassen.<br>Nach bestimmten Datenschutzgesetzen einzelner US-Bundesstaaten haben berechtigte Personen das Recht, einem Unternehmen den „Verkauf“ ihrer personenbezogenen Daten oder deren Verwendung für gezielte Werbung zu untersagen. Sie können diesem jederzeit widersprechen, indem Sie (1) die entsprechenden Cookies über die unten stehenden Schalter deaktivieren und (2) eine Anfrage über unser Online-Formular einreichen. Weitere Informationen zu Ihren Datenschutzrechten finden Sie in unseren Datenschutzhinweisen.",
              },
              {
                title: "Unbedingt erforderliche Cookies",
                description:
                  "Diese Cookies sind erforderlich, damit Sie sich auf unserer Website bewegen und deren Funktionen nutzen können, beispielsweise um auf geschützte Bereiche zuzugreifen. Ohne diese Cookies können von Ihnen angeforderte Dienste, wie etwa Warenkörbe oder die elektronische Rechnungsstellung, nicht bereitgestellt werden. Diese Cookies ermöglichen Funktionen und Dienste, die Sie ausdrücklich angefordert haben.",
                linkedCategory: "necessary",
              },
              {
                title: "Performance-Cookies",
                description:
                  "Diese Cookies erfassen Informationen darüber, wie Besucher unsere Website nutzen, beispielsweise welche Seiten am häufigsten aufgerufen werden oder ob Fehlermeldungen auftreten. Die Cookies erfassen keine Informationen, anhand derer Besucher unmittelbar identifiziert werden können. Die erhobenen Daten werden zusammengefasst und ausschließlich dazu verwendet, die Funktionsweise und Leistung unserer Website zu verbessern.",
                linkedCategory: "performance",
              },
              {
                title: "Funktionale Cookies",
                description:
                  "Diese Cookies ermöglichen es unserer Website, sich an von Ihnen getroffene Einstellungen zu erinnern, beispielsweise an Ihren Benutzernamen, Ihre Sprache oder Ihre Region. Dadurch können wir Ihnen erweiterte und stärker personalisierte Funktionen anbieten. So kann unsere Website beispielsweise Ihren Standort in einem Cookie speichern, um Ihnen regional relevante Inhalte bereitzustellen. Diese Cookies können außerdem Einstellungen wie Schriftgröße, Schriftart und andere anpassbare Seitenelemente speichern. Sie können auch für von Ihnen angeforderte Funktionen verwendet werden, etwa zum Abspielen von Videos oder zum Kommentieren eines Blogbeitrags. Die erfassten Informationen können anonymisiert werden. Diese Cookies können Ihre Aktivitäten auf anderen Websites nicht verfolgen.",
                linkedCategory: "functionality",
              },
              {
                title: "Targeting- und Werbe-Cookies",
                description:
                  "Diese Cookies werden verwendet, um Ihnen Werbung anzuzeigen, die besser zu Ihnen und Ihren Interessen passt. Sie dienen außerdem dazu, die Häufigkeit von Werbeanzeigen zu begrenzen und die Wirksamkeit von Werbekampagnen zu messen. In der Regel werden sie mit Zustimmung des Websitebetreibers von Werbenetzwerken gesetzt. Sie speichern, dass Sie unsere Website besucht haben. Diese Information kann an andere Unternehmen, beispielsweise Werbetreibende, weitergegeben werden. Targeting- und Werbe-Cookies sind häufig mit Funktionen verknüpft, die von anderen Unternehmen bereitgestellt werden. Sie erfassen Informationen über Ihr Nutzungsverhalten, um Werbung auf Ihre Interessen abzustimmen.",
                linkedCategory: "targeting",
              },
            ],
          },
        },
      },
    },
  });
});
